// extracted by mini-css-extract-plugin
export default {"spinner-container":"Spinner_spinner-container__6S-4O","spinner":"Spinner_spinner__emWYY","spin":"Spinner_spin__Qsuqz"};